import { useId, useRef, useState } from 'react';
import { validatePngFile, blobToObjectUrl, revokeObjectUrl } from '../utils/png';
import './MainPanel.css';

type Props = {
  onSave: (file: File) => Promise<void>;
  busy: boolean;
  error: string | null;
};

export function SignatureSetup({ onSave, busy, error }: Props) {
  const inputId = useId();
  const inputRef = useRef<HTMLInputElement>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [localError, setLocalError] = useState<string | null>(null);

  const clearPreview = () => {
    revokeObjectUrl(previewUrl);
    setPreviewUrl(null);
    setFile(null);
  };

  const onPick = (list: FileList | null) => {
    setLocalError(null);
    const f = list?.[0];
    if (!f) return;
    const err = validatePngFile(f);
    if (err) {
      clearPreview();
      setLocalError(err);
      if (inputRef.current) inputRef.current.value = '';
      return;
    }
    revokeObjectUrl(previewUrl);
    setFile(f);
    setPreviewUrl(blobToObjectUrl(f));
  };

  return (
    <div className="mp-section">
      <h2 className="mp-h2">Unterschrift einrichten</h2>
      <p className="mp-lead">Bitte hinterlegen Sie einmalig Ihre Unterschrift.</p>

      <label className="sp-btn sp-btn--primary" htmlFor={inputId}>
        PNG auswählen
      </label>
      <input
        id={inputId}
        ref={inputRef}
        type="file"
        accept="image/png,.png"
        className="mp-file"
        disabled={busy}
        onChange={(e) => onPick(e.target.files)}
      />

      {previewUrl ? (
        <div className="mp-preview-wrap">
          <img src={previewUrl} alt="Vorschau Unterschrift" className="mp-preview" />
        </div>
      ) : null}

      {(localError || error) && (
        <div className="sp-error" role="alert">
          <p>{localError || error}</p>
        </div>
      )}

      {file ? (
        <button
          type="button"
          className="sp-btn sp-btn--primary"
          disabled={busy}
          onClick={() => void onSave(file)}
        >
          {busy ? 'Speichern…' : 'Unterschrift speichern'}
        </button>
      ) : null}
    </div>
  );
}
